import { BROKER_LINKS } from "@/data/brokers";
import { Link } from 'react-router-dom';

interface NavColumn {
  heading: string;
  items: { label: string; to: string }[];
}

const FOOTER_NAV: NavColumn[] = [
  {
    heading: String.fromCharCode(67,244,110,103,32,99,117,249),
    items: [
      { label: String.fromCharCode(77,225,121,32,116,237,110,104,32,75,104,111,225,105,32,76,226,117,111,110,103), to: String.fromCharCode(47,109,97,121,45,116,105,110,104,45,107,104,111,105,45,108,117,111,110,103) },
      { label: String.fromCharCode(77,225,121,32,116,237,110,104,32,75,121,32,113,117,253), to: String.fromCharCode(47,109,97,121,45,116,105,110,104,45,107,121,45,113,117,121) },
      { label: String.fromCharCode(76,225,105,47,32,76,245,98,32,38,32,76,227,105,32,110,104,117,226,110), to: String.fromCharCode(47,116,105,110,104,45,116,111,97,110,45,108,111,105,45,110,104,117,97,110) },
      { label: String.fromCharCode(81,117,227,110,32,116,114,237,32,82,117,105,32,114,111), to: String.fromCharCode(47,113,117,97,110,45,116,114,105,45,114,117,105,45,114,111) },
    ],
  },
  {
    heading: String.fromCharCode(80,104,226,110,32,116,237,99,104),
    items: [
      { label: String.fromCharCode(80,104,226,110,32,116,237,99,104,32,75,121,32,116,104,117,97,116), to: String.fromCharCode(47,112,104,97,110,45,116,105,99,104,45,107,121,45,116,104,117,97,116) },
      { label: String.fromCharCode(83,111,32,115,225,110,104,32,83,112,114,101,97,100), to: String.fromCharCode(47,100,111,105,45,99,104,105,101,117,45,116,104,105,45,116,114,117,111,110,103) },
      { label: String.fromCharCode(76,237,99,104,32,84,104,237,32,116,114,224,110,103), to: String.fromCharCode(47,108,105,99,104,45,116,104,105,45,116,114,117,111,110,103) },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-[#0B1220] text-slate-300">
      {/* Decorative background */}
      <div className="pointer-events-none absolute inset-0">
        <div className="terminal-grid absolute inset-0 opacity-40" />
        <div className="absolute -top-20 left-1/4 h-80 w-80 rounded-full bg-[#7c3aed]/15 blur-3xl" />
        <div className="absolute bottom-0 right-1/3 h-80 w-80 rounded-full bg-[#10b981]/10 blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-[1200px] px-5 md:px-8">
        {/* ── Top row: Brand │ Navigation ── */}
        <div className="grid grid-cols-1 gap-12 py-16 lg:grid-cols-12 lg:gap-10 lg:py-20">
          {/* Brand */}
          <div className="lg:col-span-4">
            <Link
              to="/"
              className="inline-flex items-center whitespace-nowrap"
            >
              <img src="/images/footer_logo.png" alt="ForexTools" className="h-14 object-contain" />
            </Link>
            <p className="mt-4 text-sm leading-7 text-slate-400">
              Trung tâm công cụ Forex và máy tính giao dịch thời gian thực. Lượng
              hóa rủi ro, tối ưu khối lượng lệnh và ra quyết định dựa trên dữ liệu
              tuyệt đối — không còn phỏng đoán.
            </p>
          </div>

          {/* Navigation columns */}
          <div className="lg:col-span-8">
            <div className="grid grid-cols-2 gap-8 sm:grid-cols-2">
              {FOOTER_NAV.map((col) => (
                <div key={col.heading}>
                  <h3 className="mb-5 text-[11px] font-semibold uppercase tracking-[0.08em] text-slate-200">
                    {col.heading}
                  </h3>
                  <ul className="space-y-3">
                    {col.items.map((item) => (
                      <li key={item.label}>
                        <Link
                          to={item.to}
                          className="text-[13px] leading-relaxed text-slate-400 transition-colors hover:text-white"
                        >
                          {item.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/[0.06]" />

        {/* ── Bottom row ── */}
        <div className="flex flex-col gap-4 py-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-[11px] text-slate-500">
            © {new Date().getFullYear()} ForexTools. Bảo lưu mọi quyền.
          </p>
          
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            
            <span className="hidden items-center gap-1.5 text-[11px] text-slate-500 sm:flex">
              <span className="h-1.5 w-1.5 rounded-full bg-[#34d399]"></span>
              Máy chủ đang hoạt động
            </span>
          </div>
        </div>

        {/* Disclaimer */}
        <p className="border-t border-white/[0.04] py-6 text-[11px] leading-relaxed text-slate-600">
          Cảnh báo rủi ro: Giao dịch ngoại hối và các công cụ tài chính có đòn bẩy
          mang mức rủi ro cao, có thể không phù hợp với tất cả nhà đầu tư. Kết quả
          tính toán chỉ mang tính tham khảo và không cấu thành lời khuyên đầu tư.
          Hãy cân nhắc kỹ mục tiêu và khả năng chịu rủi ro của bạn trước khi giao dịch.
        </p>

        {/* Space reserved for the fixed status bar */}
        <div className="h-10" />
      </div>
    </footer>
  );
}